<script setup lang="ts">
defineProps<{
  senderName: string
  media?: boolean
  fromContact?: boolean
}>()
</script>
<template>
  <div
    class="tw-w-full tw-font-medium tw-leading-[0.8rem] tw-my-1 tw-text-wc-blue-400"
    :class="{
      media: media && fromContact,
    }"
  >
    <span>{{ senderName }}</span>
  </div>
</template>
<style lang="css" scoped>
.media {
  padding-left: 0.3rem;
  padding-right: 0.5rem;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}
</style>
